import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { select } from '@syncfusion/ej2-base';

export class PrimaryWeapon extends StarbaseEntity implements Serializable<PrimaryWeapon> {
    public weapon_Category: string;
    public editable: boolean; // TODO: do we need this here? Isn't this a part of IColumnModel?
    public primary_Weapon: string;
    public primaryWeaponName: string;

    constructor() {
        super();
        this.selected = false;
    }

    public static PrimaryWeaponColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
            new ColumnModel('Weapon Category', 'weapon_Category', 'weapon_Category', editable, 'string', false, true, 100, true),
            new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, true, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, true, 100, false)
        ];
    }
    public static CreatePrimaryWeaponColumnData(): IColumnModel[] {
        return [
            new ColumnModel('Weapon Category', 'weapon_Category', 'weapon_Category', true, 'string', false, true, 100, true)
        ];
    }

    public static setupPrimaryWeaponCollection(collection: PrimaryWeapon[]): void {
        of(collection).pipe(
            map((w: PrimaryWeapon[]) =>
                w.map((k: PrimaryWeapon) => {
                    k = new PrimaryWeapon().deserialize(k);
                })
            )
        ).subscribe();
    }

    deserialize(input) {
        return Object.assign(new PrimaryWeapon(), input);
    }
}
